import $ from 'gridstrap/lib/gs-zepto';
import smoothScroll = require('gridstrap/lib/smooth-scroll');
import { isTouchInterface } from 'gridstrap/lib/gs-utils';

import * as templates from './templates';
import * as config from './config';

declare var algoliasearch;
declare var autocomplete;

export class GSFormSearch {

	//
	// Properties
	//

	private root;
	private input;
	private search;
	private client;

	get id() { return this.root.prop('id'); }
	get value() { return this.input.val().trim(); }
	set value(value) { this.input.val(value.trim()); }
	set isActive(value) { this.root.toggleClass('is-focused', !!value); }

	set isDisabled(value) {
		this.root.toggleClass('is-disabled', !!value);
		if (!value) this.input.removeAttr('disabled');
		if (!!value) this.input.attr('disabled', 'disabled');
	}

	//
	// Methods
	//

	clear() {
		setTimeout(() => {
			this.value = '';
			this.input.blur();
		}, 400);
	}

	private loadLibraries(libraries) {
		return libraries.map(library => this.loadLibrary(library));
	}

	private loadLibrary(url) {
		return new Promise((success, error) => $['ajax']({
			dataType: 'script',
			cache: true,
			url, success,	error
		}));
	}

	private init() {
		let narrowPlaceholder = this.input.data('gsFormSearchPlaceholderNarrow');
		if (window.innerWidth < 500) this.input.attr('placeholder', narrowPlaceholder);

		this.client = algoliasearch(config.appId, config.apiKey);
		let categories = this.client.initIndex('sc-categories');
		let products = this.client.initIndex('sc-products');

		this.isDisabled = false;

		config.options.templates = templates.main;
		config.options.dropdownMenuContainer = `#${this.id}_results`;

		this.search = autocomplete(`#${this.id}_input`, config.options, [{
			source: autocomplete.sources.hits(categories, config.source),
			displayKey: 'categoryName',
			templates: templates.category
		}, {
			source: autocomplete.sources.hits(products, config.source),
			displayKey: 'productName',
			templates: templates.product
		}]);

		this.search.on({
			'autocomplete:selected': (e, s) => location.href = s.pageUrl,
			'autocomplete:closed': () => this.search.autocomplete.setVal('')
		});
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.input = this.root.find('.gs-FormSearch-input');

		this.input.on({
			focus: () => this.handleFocus(),
			blur: () => this.isActive = false,
			keydown: evt => this.handleKeydown(evt)
		});

		this.root.on('click', 'gs-FormSearch-empty', () => this.clear());

		Promise.all(this.loadLibraries([
			'https://cdn.jsdelivr.net/algoliasearch/3/algoliasearch.min.js',
			'https://cdn.jsdelivr.net/autocomplete.js/0/autocomplete.min.js'
		])).then(() => this.init());
	}

	gsOnDestroy() {
		this.input.off();
		this.search.autocomplete.destroy();
		this.client.destroy();
	}

	handleKeydown(evt) {
		const keyCode = evt.which || evt.keyCode;
		if (keyCode === 27 && this.value === '') this.input.blur();
	}

	handleFocus() {
		this.isActive = true;
		if (!isTouchInterface()) return;
		if (window.innerHeight > 1200) return;

		let pos = this.input.offset().top - 20;
		setTimeout(() => smoothScroll.animateScroll(pos), 250);
	}
}
